/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_TransportInputs */



/**
* | output |
* | --- |
* | "The connection to the AI provider was interrupted. Please try again." |
*
* @param {Chat_Error_TransportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_transport = /** @type {((inputs?: Chat_Error_TransportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_TransportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Verbindung zum KI-Anbieter wurde unterbrochen. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("The connection to the AI provider was interrupted. Please try again.")
});